import React, { useEffect, useRef, useState } from 'react';

import { BackButton, ContinueButton } from '../../components/buttons/Buttons';
import { useTenant } from '../../context/TenantContext';
import useTrackEvent from '../../utils/trackEvent';
import ConDetalle from './ConDetalle';
import SinDetalle from './SinDetalle';

const InfoCredito = ({ onPreviousStep, data }) => {
  const [selectedValue, setSelectedValue] = useState('');
  const [currentScreen, setCurrentScreen] = useState('default');
  const hasPushedPageView = useRef(false);
  const { pushPageView, pushCustomEvent } = useTrackEvent();
  const { isMeliTenant } = useTenant();

  useEffect(() => {
    if (!hasPushedPageView.current) {
      pushPageView(
        'vpv',
        'Refinanciamiento',
        '1.1',
        '/refinancia-tu-credito/detalle-deuda',
        'Detalle Deuda - Refinanciamiento'
      );

      hasPushedPageView.current = true;
    }
  }, []);

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleRadioClick = (value) => {
    setSelectedValue(value);
  };

  const handleNextStep = () => {
    pushCustomEvent('event_buttons', {
      flujo: 'Refinanciamiento',
      button_step_value: '1.1',
      step: '1.1',
      page: '/refinancia-tu-credito/detalle-deuda',
      PageName: 'Detalle Deuda - Refinanciamiento',
      button_step_name: 'continuar',
      estado: selectedValue === 'conDetalle' ? 'conoce' : 'no conoce',
      version: 'v2',
    });

    if (selectedValue === 'conDetalle') {
      setCurrentScreen('conDetalle');
    } else if (selectedValue === 'sinDetalle') {
      setCurrentScreen('sinDetalle');
    }
  };

  const handlePreviousStep = () => {
    onPreviousStep(data);
  };

  const handleBackToInfoCredito = () => {
    setCurrentScreen('default');
  };

  return (
    <div className="button-container">
      {currentScreen === 'default' && (
        <>
          <div className="button-container-content">
            <h1>Información del crédito</h1>
            <p>Ahora debes definir si conoces el detalle de tu deuda</p>
            <div
              className={`option-container ${selectedValue === 'conDetalle' ? 'selected' : ''}`}
              onClick={() => handleRadioClick('conDetalle')}
            >
              <input
                type="radio"
                name="infoCredito"
                value="conDetalle"
                checked={selectedValue === 'conDetalle'}
                onChange={handleRadioChange}
              />
              <span className="button-label">Tengo claro el monto de mi deuda</span>
            </div>

            <div
              className={`option-container ${selectedValue === 'sinDetalle' ? 'selected' : ''}`}
              onClick={() => handleRadioClick('sinDetalle')}
            >
              <input
                type="radio"
                name="infoCredito"
                value="sinDetalle"
                checked={selectedValue === 'sinDetalle'}
                onChange={handleRadioChange}
              />
              <span className="button-label">No tengo el detalle de mi deuda</span>
            </div>

            <div className="nav-button-container">
              <BackButton onClick={() => handlePreviousStep()} />
              <ContinueButton onClick={() => handleNextStep()} isMeliTenant={isMeliTenant} />
            </div>
          </div>
        </>
      )}

      {/* Renderiza Condicionalmente las pantallas seleccionadas */}
      {currentScreen === 'conDetalle' && (
        <ConDetalle onBack={handleBackToInfoCredito} isMeliTenant={isMeliTenant} />
      )}
      {currentScreen === 'sinDetalle' && (
        <SinDetalle onBack={handleBackToInfoCredito} isMeliTenant={isMeliTenant} />
      )}
    </div>
  );
};

export default InfoCredito;
